import React, { useEffect, useState } from "react";
import Conversations from "../../../../../components/Processes/conversations/Conversations";
import useMessages from "../../../actions/useMessages";
import TemporaryNotification from "~/components/toast-notification/AttachmentTemporaryNotification";
import AttachmentSuccess from "~/components/toast-notification/AttachmentSuccess";

const PublicConversations = () => {
  const [restoreSuccess, setRestoreSuccess] = useState("");
  const {
    fetchPublicMessages,
    isMessageLoading,
    formatDate,
    setIsMessageLoading,
    isPublic,
    deleteConversation,
    deleteLoading,
    setDeleteLoading,
    deleteModal,
    setDeleteModal,
    selectedMessage,
    setSelectedMessage,
    processdata,
    deleteCommentModal,
    setDeleteCommentModal,
    notificationMessage,
    setNotificationMessage,
    restoreConversation,
    resetPaginationState,
    data,
    hasMorePrevData,
    hasMoreNextData,
    isDataFetching,
  } = useMessages({
    fetchMessages: () => {},
    relatedType: "PROCESS",
    serviceData: {},
  });

  // Initial fetch on mount
  useEffect(() => {
    const getMessages = async () => {
      setIsMessageLoading(true);
      await fetchPublicMessages("INITIAL");
      // console.log("✅ Initial load complete");
    };

    getMessages();
  }, []);

  // Fetch messages handler
  // GXM-1754: Added skipCache param to bypass APIM 60s cache after mutations
  const fetchMessageshandler = async (
    fetchDataType = "INITIAL",
    skipCache = false,
  ) => {
    try {
      if (fetchDataType === "INITIAL") {
        resetPaginationState();
        setIsMessageLoading(true);
        await fetchPublicMessages("INITIAL", skipCache);
      } else if (fetchDataType === "FETCHPREVDATA") {
        await fetchPublicMessages("FETCHPREVDATA", skipCache);
      } else if (fetchDataType === "FETCHNEXTDATA") {
        await fetchPublicMessages("FETCHNEXTDATA", skipCache);
      }
    } catch (error) {
      setIsMessageLoading(false);
    }
  };

  const deleteConversationHandler = async (id) => {
    await deleteConversation(id);
    setDeleteLoading(false);
    setRestoreSuccess("");
    setNotificationMessage(
      "Your message and document has been deleted from this conversation.",
    );
    setDeleteCommentModal(false);
    setDeleteModal(false);
    await fetchMessageshandler("INITIAL", true); // GXM-1754: skipCache after delete
  };

  const restoreConversationHandler = async () => {
    setDeleteLoading(false);
    await restoreConversation(selectedMessage.id);
    setNotificationMessage("");
    setSelectedMessage(null);
    setRestoreSuccess(
      "Your message or document has been restored successfully.",
    );
    setTimeout(async () => {
      await fetchMessageshandler("INITIAL", true); // GXM-1754: skipCache after restore
    }, 2000);
  };

  return (
    <>
      {restoreSuccess && (
        <AttachmentSuccess
          setMessages={setRestoreSuccess}
          successMsg={restoreSuccess}
        />
      )}
      {notificationMessage && (
        <TemporaryNotification
          setMessages={setNotificationMessage}
          successMsg={notificationMessage}
          onUndo={restoreConversationHandler}
        />
      )}
      <Conversations
        messages={data}
        fetchMessages={fetchMessageshandler}
        isMessageLoading={isMessageLoading}
        formatDate={formatDate}
        isPublic={isPublic}
        deleteConversation={deleteConversationHandler}
        isDeleteLoading={deleteLoading}
        setDeleteLoading={setDeleteLoading}
        deleteModal={deleteModal}
        setDeleteModal={setDeleteModal}
        selectedMessage={selectedMessage}
        setSelectedMessage={setSelectedMessage}
        entitydata={processdata?.entityData}
        processdata={processdata}
        relatedType="PROCESS"
        deleteComment={deleteCommentModal}
        setDeleteComment={setDeleteCommentModal}
        hasMorePrevData={hasMorePrevData}
        hasMoreNextData={hasMoreNextData}
        isDataFetching={isDataFetching}
      />
    </>
  );
};

export default PublicConversations;
